// extracted by mini-css-extract-plugin
module.exports = {"rotation":"TecnologieDetailTemplate_rotation__pVjxO"};